import api from './axiosInstance';

export const getExpensesApi = (params) => api.get('/user/expanses', { params });
export const getExpenseNamesApi = (params) => api.get('/get-expense-names', { params });
export const createExpenseApi = (formData) => api.post('/user/create-expense-new', formData);
export const updateExpenseApi = (formData) => api.post('/user/expense/update', formData);
export const deleteExpenseApi = (data)     => api.post('/user/expense/delete', data);
export const updateExpenseImageApi = (formData) => api.post('/update-expance-image', formData);
export const updateExpenseDateNoteApi = (data) => api.patch('/update-expense-date-note', data);
export const getExpenseDetailsApi = (params) => api.get('/expense-details', { params });
export const changeExpensePaymentStatusApi    = (data) => api.post('/change-expense-payment-status', data);
export const changeLabourTransactionStatusApi = (data) => api.patch('/transactions/status', data);
export const addLabourTransactionApi          = (data) => api.post('/add-labour-transaction', data);
export const updateLabourTransactionApi       = (data) => api.patch('/update-labour-transaction', data);
export const deleteLabourTransactionApi       = (data) => api.delete('/delete-labour-transaction', { data });

// ── EXPENSE PAYMENT LOGS ───────────────────────────────────────────────────
export const getKharchoPaymentLogsApi     = (data)     => api.post('/user/kharcho-payment-log',        data);
export const addKharchoPaymentLogApi      = (formData) => api.post('/user/kharcho-payment-log/add',    formData);
export const deleteKharchoPaymentLogApi   = (data)     => api.post('/user/kharcho-payment-log/delete', data);
export const addKharchoPaymentLogImageApi = (formData) => api.post('/user/kharcho-payment-log/image',  formData);
